import i18n from '@/common/i18n';
import computedLocale from '@/common/utils/computedLocale';

export const USER_TYPES = {
  LOCAL: 'local',
  FEDERATED: 'federated'
};

export const USER_TYPE_TEXT = computedLocale(() => ({
  [USER_TYPES.LOCAL]: i18n.t('Local'),
  [USER_TYPES.FEDERATED]: i18n.t('Federated')
}));
